var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({staticClass:"toggle-button",class:{
    [_vm.toggleOnClass]: _vm.internalValue,
    [_vm.toggleOffClass]: !_vm.internalValue
  },on:{"click":_vm.toggleValue},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope)]}}}),_vm._l((_vm.$slots),function(_,name){return {key:name,fn:function(){return [_vm._t(name)]},proxy:true}})],null,true)},'v-btn',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }